"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Product = void 0;
var ChangeCase = require("change-case");
var utils_1 = require("../../../utils");
var offer_1 = require("../offer");
var Product = /** @class */ (function (_super) {
    __extends(Product, _super);
    function Product() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @deprecated - use variants collection
     */
    Product.getVariant = function (variantId, product) {
        for (var seller in product.sellerMeta) {
            if (!product.sellerMeta.hasOwnProperty(seller)) {
                throw new Error('Not allowed');
            }
            for (var _i = 0, _a = product.sellerMeta[seller].variants; _i < _a.length; _i++) {
                var variant = _a[_i];
                if (variant.id === variantId) {
                    return variant;
                }
            }
        }
        return null;
    };
    /**
     * @deprecated - use seller document
     */
    Product.getRetailerMetadataFromVariant = function (variantId, product) {
        for (var seller in product.sellerMeta) {
            if (!product.sellerMeta.hasOwnProperty(seller)) {
                throw new Error('Not allowed');
            }
            for (var _i = 0, _a = product.sellerMeta[seller].variants; _i < _a.length; _i++) {
                var variant = _a[_i];
                if (variant.id === variantId) {
                    return { retailerId: seller, metadata: product.sellerMeta[seller] };
                }
            }
        }
        return null;
    };
    Product.defaultProps = function (type, name, manufacturer) {
        return __assign(__assign({}, offer_1.Offer.defaultProps(type, name, manufacturer)), { type: type, types: utils_1.TypeMapper.parentRelations(type, 'product'), manufacturer: ChangeCase.constantCase(manufacturer), quality: 0, sellerMeta: {} });
    };
    Product.defaultRetailMetadata = function (product, seller) {
        return {
            id: seller,
            lastUpdated: new Date().toISOString(),
            rating: {
                value: null,
                max: 5,
                reviews: null
            },
            affiliateLink: null,
            productLink: null,
            questions: null,
            variants: []
        };
    };
    Product.defaultVariant = function (product, seller, variantName) {
        return {
            id: product.id + ";;" + ChangeCase.constantCase(seller) + ";;" + ChangeCase.constantCase(variantName),
            variant: {},
            name: variantName,
            size: {
                weight: null,
                measurement: 'lbs',
                length: {
                    value: null,
                    measurement: 'in'
                },
                width: {
                    value: null,
                    measurement: 'in'
                },
                height: {
                    value: null,
                    measurement: 'in'
                },
                volume: null
            },
            color: null,
            instock: null,
            pricing: {
                currency: 'USD',
                listPrice: null,
                offerPrice: null,
                lowestPrice: null // Full discounts applied (using Prime, Chewy's Autoship, etc)
            },
            itemNo: null,
            externalAttributes: {},
            internalAttributes: {},
            dynamicAttributes: null,
            minShipDays: null,
            maxShipDays: null
        };
    };
    return Product;
}(offer_1.Offer));
exports.Product = Product;
